var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_3202_424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33301 6H10.6663",
    stroke: "#5A638C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.33301 8.66699H7.66634",
    stroke: "#5A638C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7 13.0003L6 12.0003H4C3.46957 12.0003 2.96086 11.7896 2.58579 11.4145C2.21071 11.0395 2 10.5308 2 10.0003V4.66699C2 4.13656 2.21071 3.62785 2.58579 3.25278C2.96086 2.87771 3.46957 2.66699 4 2.66699H12C12.5304 2.66699 13.0391 2.87771 13.4142 3.25278C13.7893 3.62785 14 4.13656 14 4.66699V7.33366",
    stroke: "#5A638C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.9998 14.6664L14.2331 12.4771C14.37 12.3442 14.479 12.1852 14.5535 12.0095C14.628 11.8338 14.6665 11.645 14.6668 11.4541C14.6671 11.2633 14.6292 11.0743 14.5553 10.8984C14.4814 10.7224 14.3729 10.5631 14.2364 10.4297C13.9578 10.1573 13.5839 10.0044 13.1942 10.0037C12.8046 10.0029 12.43 10.1544 12.1504 10.4257L12.0011 10.5724L11.8524 10.4257C11.5739 10.1535 11.2001 10.0007 10.8106 10C10.4211 9.99926 10.0467 10.1506 9.76709 10.4217C9.63009 10.5546 9.52109 10.7136 9.44654 10.8892C9.37199 11.0649 9.33338 11.2537 9.33301 11.4446C9.33264 11.6354 9.3705 11.8244 9.44437 12.0004C9.51824 12.1763 9.62661 12.3357 9.76309 12.4691L11.9998 14.6664Z",
    stroke: "#5A638C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3202_424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreeting);
export default __webpack_public_path__ + "static/media/greeting.f757f9b0.svg";
export { ForwardRef as ReactComponent };